import { BasicDetails, State, Template, TemplateLayout, TemplateType, User, WorkflowItem } from './interfaces';
import { AccessibilityProfiles } from '../constants';
import { defaultBranding } from '../constants';
import { useStore } from './store';
import {
  SET_BASIC_DETAILS,
  UPDATE_CURRENT_WORKFLOW_ITEM,
  UPDATE_TEMPLATE,
  UPDATE_CANDIDATE,
  UPDATE_HEADER_DETAILS,
  UPDATE_HEADER_OPTIONS,
  UPDATE_USER_INACTIVITY,
  UPDATE_TIMELINE_SPINNER_STATE,
  UPDATE_TIMELINE_STYLE,
} from './action';
import { HeaderResponse, HeaderOptions } from '../base/interfaces/headerInterface';

/** Initial state for StoreProvider */
export const initialState: State = {
  currentWorkflowItem: {
    id: '0',
    code: '',
    capturesPii: false,
    lastItem: false,
    configuration: '',
  },
  headerOptions: {
    accessibility: AccessibilityProfiles,
    selectedTheme: 0,
    isAssessment: false,
    exit: false,
  },
  headerDetails: {
    accessibility: '',
    companyName: '',
    language: '',
    showDetails: false,
    showDpn: false,
    showEeo: false,
    showOfccp: false,
    showResearchQuestions: false,
    isVrProject: false,
    isICPEnabled: false,
    isShlAppEnabled: false,
    langGroups: [],
  },
  template: {
    layoutCode: TemplateLayout.TEMPLATE_LAYOUT_01,
    id: '',
    type: TemplateType.EXPERIENCE_LITE,
    status: '',
    companyId: 0,
    firstWorkflowItemId: '0',
    settings: defaultBranding,
  },

  userSessionActive: false,
  isUserInactive: false,
  timeLineSpinner: false,
  timelineStyle: false,
};

/**
 * Store for basic details for experience-lite
 */
interface BasicDetailsStore {
  candidate?: User;
  headerDetails: HeaderResponse;
  headerOptions: HeaderOptions;
  currentWorkflowItem: WorkflowItem;
  template: Template;
  userSessionActive: boolean;
  isUserInactive: boolean;
  timeLineSpinner: boolean;
  timelineStyle: boolean;
  setBasicDetails: (basicDetails: BasicDetails) => void;
  updateTemplate: (template: Template) => void;
  updateCurrentWorkflowItem: (currentWorkflowItem: WorkflowItem) => void;
  updateCandidate: (candidate: User) => void;
  updateHeaderDetails: (header: HeaderResponse) => void;
  updateHeaderOptions: (header: HeaderOptions) => void;
  updateUserInactivity: (isUserInactive: boolean) => void;
  updateTimeLineSpinner: (timeLineSpinner: boolean) => void;
  updateTimeLineStyle: (timelineStyle: boolean) => void;
}

export const useBasicDetails = (): BasicDetailsStore => {
  const { state, dispatch } = useStore();

  return {
    candidate: state.candidate,
    headerDetails: state.headerDetails,
    headerOptions: state.headerOptions,
    currentWorkflowItem: state.currentWorkflowItem,
    template: state.template,
    userSessionActive: state.userSessionActive,
    isUserInactive: state.isUserInactive,
    timeLineSpinner: state.timeLineSpinner,
    timelineStyle: state.timelineStyle,
    setBasicDetails: (basicDetails: BasicDetails): void => dispatch({ type: SET_BASIC_DETAILS, payload: basicDetails }),
    updateCurrentWorkflowItem: (currentWorkflowItem: WorkflowItem): void =>
      dispatch({ type: UPDATE_CURRENT_WORKFLOW_ITEM, payload: currentWorkflowItem }),
    updateTemplate: (template: Template): void => dispatch({ type: UPDATE_TEMPLATE, payload: template }),
    updateCandidate: (candidate: User): void => dispatch({ type: UPDATE_CANDIDATE, payload: candidate }),
    updateHeaderDetails: (header: HeaderResponse): void => dispatch({ type: UPDATE_HEADER_DETAILS, payload: header }),
    updateHeaderOptions: (header: HeaderOptions): void => dispatch({ type: UPDATE_HEADER_OPTIONS, payload: header }),
    updateUserInactivity: (isUserInactive: boolean): void =>
      dispatch({ type: UPDATE_USER_INACTIVITY, payload: isUserInactive }),
    updateTimeLineSpinner: (timeLineSpinner: boolean): void =>
      dispatch({ type: UPDATE_TIMELINE_SPINNER_STATE, payload: timeLineSpinner }),
    updateTimeLineStyle: (timelineStyle: boolean): void =>
      dispatch({ type: UPDATE_TIMELINE_STYLE, payload: timelineStyle }),
  };
};
